import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private loginService : UseraccessserviceService,private router :Router, private headerinfo: ComponentheaderService ) { }

  ngOnInit(): void {
    this.loginService.logout();
    this.headerinfo.setPageTitle('Logout');
  }

}
